import { useCallback } from 'react';
import type { FormField } from '../contexts';
import { useWidgetDispatch } from '../contexts';
import { useFormReset } from './useFormReset';

export function useWidgetClose(editMode: boolean, fields: FormField[]) {
  const dispatch = useWidgetDispatch();
  const resetForm = useFormReset(fields);

  return useCallback(() => {
    dispatch({
      type: 'toggleClose',
      closed: true
    });

    resetForm();

    if (editMode) {
      const resetTimeout = setTimeout(() => {
        dispatch({
          type: 'resetWidget'
        });
      }, 2000);

      return () => clearTimeout(resetTimeout);
    }

    return;
  }, [editMode, dispatch, resetForm]);
}
